<div class="eli-shell">

  <!-- HEADER -->
  <div class="eli-header">
    <button class="btn-voltar" (click)="onVoltar()">
      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"
        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <polyline points="15 18 9 12 15 6"/>
      </svg>
      Voltar
    </button>
    <div class="header-info">
      <div class="header-nunota">#{{ nunota }}</div>
      <div class="header-cliente">{{ clienteNome }}</div>
    </div>
    <button class="btn-finalizar"
      [disabled]="!allDone || finalizando"
      (click)="finalizar()">
      {{ finalizando ? 'Confirmando...' : 'Confirmar Envio' }}
    </button>
  </div>

  <!-- ERRO FINALIZAR -->
  <div *ngIf="erroFinalizar" class="alert alert-danger" style="margin: 16px 20px 0;">
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
      stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
      <circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/>
    </svg>
    {{ erroFinalizar }}
  </div>

  <!-- LOADING -->
  <div *ngIf="carregando" class="loading-state">
    <app-loading-indicator></app-loading-indicator>
    <span>Carregando itens...</span>
  </div>

  <!-- ERRO CARREGAR -->
  <div *ngIf="erro && !carregando" class="alert alert-danger" style="margin: 24px;">
    {{ erro }}
  </div>

  <!-- CONTEÚDO -->
  <div *ngIf="!carregando && !erro" class="eli-content">

    <!-- BARRA DE PROGRESSO -->
    <div class="progresso-wrap">
      <div class="progresso-info">
        <span class="progresso-label">Progresso</span>
        <span class="progresso-nums">{{ itensConferidos.length }} / {{ itens.length }} itens</span>
        <span class="progresso-pct">{{ progresso }}%</span>
      </div>
      <div class="progresso-bar">
        <div class="progresso-fill" [style.width.%]="progresso"></div>
      </div>
    </div>

    <!-- ABAS -->
    <div class="abas-wrap">
      <button class="aba-btn" [class.active]="abaAtiva === 'pendentes'" (click)="abaAtiva = 'pendentes'">
        A Verificar
        <span class="aba-count">{{ itensPendentes.length }}</span>
      </button>
      <button class="aba-btn" [class.active]="abaAtiva === 'conferidos'" (click)="abaAtiva = 'conferidos'">
        Verificados
        <span class="aba-count done">{{ itensConferidos.length }}</span>
      </button>
    </div>

    <!-- LISTA PENDENTES -->
    <div class="itens-lista" *ngIf="abaAtiva === 'pendentes'">
      <div *ngIf="itensPendentes.length === 0" class="empty-aba">
        <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
          <rect x="1" y="3" width="15" height="13" rx="1"/>
          <path d="M16 8h4l3 4v4h-7V8z"/>
          <circle cx="5.5" cy="18.5" r="2.5"/>
          <circle cx="18.5" cy="18.5" r="2.5"/>
        </svg>
        <p>Todos os itens verificados!</p>
      </div>

      <div class="item-row" *ngFor="let item of itensPendentes">
        <div class="item-check-wrap" (click)="toggleItem(item)">
          <div class="checkbox-circle"></div>
        </div>
        <div class="item-info">
          <div class="item-top">
            <span class="item-seq">#{{ item.seq }}</span>
            <span class="item-cod">{{ item.codprod }}</span>
            <span class="item-ref" *ngIf="item.refforn">{{ item.refforn }}</span>
          </div>
          <div class="item-desc">{{ item.descricao }}</div>
          <div class="item-bottom">
            <span class="item-qtd">{{ item.qtd | number:'1.0-2' }} {{ item.unidade }}</span>
            <span class="item-local" *ngIf="item.local">{{ item.local }}</span>
            <span class="item-cond" *ngIf="item.condicao">{{ item.condicao }}</span>
          </div>
        </div>
        <button class="btn-conferir" (click)="toggleItem(item)">
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
            <polyline points="20 6 9 17 4 12"/>
          </svg>
        </button>
      </div>
    </div>

    <!-- LISTA VERIFICADOS -->
    <div class="itens-lista" *ngIf="abaAtiva === 'conferidos'">
      <div *ngIf="itensConferidos.length === 0" class="empty-aba">
        <p>Nenhum item verificado ainda.</p>
      </div>

      <div class="item-row item-row--done" *ngFor="let item of itensConferidos">
        <div class="item-check-wrap done" (click)="toggleItem(item)">
          <div class="checkbox-circle checked">
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round">
              <polyline points="20 6 9 17 4 12"/>
            </svg>
          </div>
        </div>
        <div class="item-info">
          <div class="item-top">
            <span class="item-seq">#{{ item.seq }}</span>
            <span class="item-cod">{{ item.codprod }}</span>
            <span class="item-ref" *ngIf="item.refforn">{{ item.refforn }}</span>
          </div>
          <div class="item-desc done-text">{{ item.descricao }}</div>
          <div class="item-bottom">
            <span class="item-qtd">{{ item.qtd | number:'1.0-2' }} {{ item.unidade }}</span>
            <span class="item-local" *ngIf="item.local">{{ item.local }}</span>
          </div>
        </div>
        <button class="btn-desconferir" (click)="toggleItem(item)" title="Desmarcar">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
          </svg>
        </button>
      </div>
    </div>

  </div>

  <!-- MODAL CONFIRMAR ENVIO -->
  <div class="modal-overlay" *ngIf="modalFinalizar" (click)="modalFinalizar = false">
    <div class="modal-box" (click)="$event.stopPropagation()">
      <div class="modal-icon">
        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <rect x="1" y="3" width="15" height="13" rx="1"/>
          <path d="M16 8h4l3 4v4h-7V8z"/>
          <circle cx="5.5" cy="18.5" r="2.5"/>
          <circle cx="18.5" cy="18.5" r="2.5"/>
        </svg>
      </div>
      <h3>Tudo verificado!</h3>
      <p>Todos os {{ itens.length }} itens foram verificados. Confirmar o envio e finalizar o pedido?</p>
      <div class="modal-actions">
        <button class="btn-modal-cancel" (click)="modalFinalizar = false">Revisar</button>
        <button class="btn-modal-confirm" (click)="finalizarDoModal()">
          {{ finalizando ? 'Confirmando...' : 'Confirmar Envio' }}
        </button>
      </div>
    </div>
  </div>

</div>
